module.exports = __webpack_public_path__ + "static/media/amsterdam.74e21221.jpg";